// extracted by mini-css-extract-plugin
module.exports = {"entering":"transition-slideLeft-module--entering--2e4uz","entered":"transition-slideLeft-module--entered--1Syd1","exiting":"transition-slideLeft-module--exiting--cU-3n"};